/* eslint-disable */
import React, { forwardRef, useRef } from "react";

import useBlurDetection from "./hooks/useBlurDetection";

import Sidebar, { SidebarProps } from "./index";

export interface SidebarWithBlurProps extends SidebarProps {
  enableEscapeKey?: boolean;
  enableClickOutside?: boolean;
  ignoreSelectors?: string[];
}

const SidebarWithBlur = forwardRef<HTMLDivElement, SidebarWithBlurProps>(
  (
    {
      isOpen,
      onClose,
      enableEscapeKey = true,
      enableClickOutside = true,
      ignoreSelectors = [],
      children,
      hasFooter,
      ...restProps
    },
    ref,
  ) => {
    const sidebarRef = useRef<HTMLDivElement>(null);
    const combinedRef = ref || sidebarRef;

    useBlurDetection({
      isOpen,
      onClose,
      sidebarRef: combinedRef as React.RefObject<HTMLDivElement>,
      isResizing: false, // This could be enhanced to track resizing state if needed
      enableEscapeKey,
      enableClickOutside,
      ignoreSelectors,
    });

    return (
      <Sidebar
        ref={combinedRef}
        isOpen={isOpen}
        onClose={onClose}
        hasFooter={hasFooter}
        {...restProps}
      >
        {children}
      </Sidebar>
    );
  },
);

SidebarWithBlur.displayName = "SidebarWithBlur";

export default SidebarWithBlur;
